import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskWidgetRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-widget',
	path: '/jira/servicedesk/projects/:projectKey/settings/widget',
	exact: true,
};
